module.exports = __webpack_public_path__ + "img/dashboard-section-activate.73bd2ea9.svg";